import FilterDropdown from 'components/shared/FilterFields/FilterDropdown'
import FilterCheckbox from 'components/shared/FilterFields/FilterCheckbox'
import Search from 'components/shared/Search/Search'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'

import './Filter.scss'

const dropdowns = {
  interests: 'interests',
  hardware: 'hardware',
  software: 'software',
  level: 'difficulty_level',
}

export const getDropdown = (key, navigate, locale, location, name, t) => (
  <FilterDropdown
    className={`c-filter__dropdown ${key}`}
    navigate={navigate}
    key={key}
    label={t(`filter.${key}.label`)}
    locale={locale}
    location={location}
    name={`${name}[]`}
    options={getOptions(t, key)}
    tabIndex={0}
  />
)

export const getCheckbox = (key, navigate, locale, location, name, t) => (
  <FilterCheckbox
    className={`c-filter__checkbox ${key}`}
    navigate={navigate}
    label={t(`filter.${key}.label`)}
    locale={locale}
    location={location}
    name={`${name}[]`}
    tabIndex={0}
  />
)

export const getOptions = (t, key) =>
  t(`filter.${key}.options`, { returnObjects: true })

export const Filter = ({ navigate, location, t, i18n }) => (
  <div className="c-filter__container">
    <div className="c-filter u-clearfix">
      <input
        className="c-filter__toggle-checkbox u-hidden"
        id="c-filter__toggle-checkbox"
        type="checkbox"
      />
      <label
        className="c-filter__toggle-trigger"
        htmlFor="c-filter__toggle-checkbox"
      >
        {t('filter.title')} <span className="c-filter__toggle-trigger-icon" />
      </label>
      <div className="c-filter__user-interfaces">
        <div className="c-filter__dropdowns" role="navigation">
          {Object.entries(dropdowns).map(([key, name]) =>
            getDropdown(key, navigate, i18n.language, location, name, t)
          )}
          {getCheckbox('pdf', navigate, i18n.language, location, 'pdf', t)}
        </div>
        <Search
          className={'c-filter__search'}
          placeholder={t('filter.search.placeholder')}
          location={location}
        />
      </div>
    </div>
  </div>
)

Filter.propTypes = {
  locale: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired,
}

export default withNamespaces('translations')(Filter)
